module.exports = __webpack_public_path__ + "static/media/zielony_normal.dd3c2913.png";